import { useParams } from "react-router-dom";
import { useEffect, useState, CSSProperties } from "react";
import { detailcommande } from "../../../Modeles/Commande";
import DetailCommandeService from "../../../Services/Admin/DetailCommandeService";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import { formatCodeCommande } from "../../../Services/CodeTrackingHelper";
import PayArticleModal from "../../Common/PayArticleModal";

export interface CommandeType {
  product: detailcommande[];
  messageErrors: string;
}

export default function DetailCommandeCommercial() {
  const { orderId } = useParams<{ orderId: string }>();
  const [state, setState] = useState<CommandeType>({
    product: [] as detailcommande[],
    messageErrors: "Aucune commande",
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const [itemToPay, setItemToPay] = useState<detailcommande | null>(null);
  const [localSuccess, setLocalSuccess] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await DetailCommandeService(orderId).getCommandeDetailsAdmin();
        setState({ product: res.data, messageErrors: "" });
      } catch (error) {
        setState({ product: [], messageErrors: "Erreur de chargement des détails." });
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [orderId]);

  const { product, messageErrors } = state;
  const totalCommande = product && product.length > 0
    ? product.reduce((acc, curr) => acc + (Number(curr.prix || 0) * Number(curr.quantity || 1)), 0)
    : 0;

  const handleGoBack = () => {
    window.history.back();
  };

  const mobileStyles: Record<string, CSSProperties> = {
    container: {
      padding: "20px 15px",
      width: "100%",
      overflowX: "hidden",
      backgroundColor: "#f9fafb",
      minHeight: "100vh"
    },
    heading: {
      fontSize: "20px",
      fontWeight: 700,
      color: "#1f2937",
      margin: "15px 0",
    },
    backButton: {
      fontSize: "28px",
      cursor: "pointer",
      color: "#6366f1"
    },
    cardContainer: {
      marginTop: "15px",
    },
    card: {
      backgroundColor: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: "12px",
      padding: "16px",
      marginBottom: "15px",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    },
    cardItem: {
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 0",
      borderBottom: "1px solid #f3f4f6",
    },
    label: {
      fontWeight: 600,
      color: "#4b5563",
    },
    value: {
      color: "#1f2937",
      fontWeight: 500
    },
    emptyMessage: {
      textAlign: "center",
      margin: "40px 0",
      color: "#9ca3af",
    },
  };

  return (
    <>
      <NewSidebareCommercial />
      <div style={{ paddingLeft: isMobile ? '0' : '80px', minHeight: '100vh', backgroundColor: '#f9fafb' }}>
        {isMobile ? (
          // Mobile View
          <div style={mobileStyles.container}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i
                onClick={handleGoBack}
                className="bi bi-arrow-left-short"
                style={mobileStyles.backButton}
              ></i>
              <span onClick={handleGoBack} style={{ fontSize: '16px', fontWeight: 500, color: '#6366f1', cursor: 'pointer' }}>Retour</span>
            </div>
            <h4 style={mobileStyles.heading}>Détails de la commande</h4>
            <p style={{ fontFamily: 'monospace', color: '#6366f1', fontWeight: 600, marginBottom: '16px', fontSize: '0.9rem' }}>
              {formatCodeCommande(undefined, orderId)}
            </p>

            <div style={mobileStyles.cardContainer}>
              {loading ? (
                <div style={{ textAlign: 'center', marginTop: '40px' }}>
                  <div className="spinner-border text-primary" role="status"></div>
                  <p style={{ marginTop: '10px', color: '#6b7280' }}>Chargement...</p>
                </div>
              ) : product && product.length > 0 ? (
                product.map((pro) => (
                  <div key={pro.idCommande} style={mobileStyles.card}>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Réf Article:</span>
                      <span style={mobileStyles.value}>{pro.RefArticle}</span>
                    </div>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Article:</span>
                      <span style={mobileStyles.value}>{pro.NomArticle}</span>
                    </div>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Prix:</span>
                      <span style={mobileStyles.value}>{pro.prix} MAD</span>
                    </div>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Quantité:</span>
                      <span style={mobileStyles.value}>{pro.quantity}</span>
                    </div>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Vendeur:</span>
                      <span style={mobileStyles.value}>{pro.vendeur}</span>
                    </div>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Statut:</span>
                      <span style={{ 
                        ...mobileStyles.value, 
                        color: pro.Statut === "confirmé" ? "#10b981" : pro.Statut === "annulé" ? "#ef4444" : "#f59e0b" 
                      }}>{pro.Statut}</span>
                    </div>
                    <div style={mobileStyles.cardItem}>
                      <span style={mobileStyles.label}>Date:</span>
                      <span style={mobileStyles.value}>{pro.created_at}</span>
                    </div>
                    <div style={{ ...mobileStyles.cardItem, borderBottom: 'none', paddingTop: '10px' }}>
                      <span style={mobileStyles.label}>Action:</span>
                      <div>
                        {(() => {
                          const sLower = (pro.Statut || "").toLowerCase();
                          if (sLower.includes("pay") || sLower.includes("confirm")) {
                            return <span className="badge bg-success">✓ Payé</span>;
                          }
                          if (sLower.includes("annul")) {
                            return <span className="badge bg-danger">✕ Annulé</span>;
                          }
                          return (
                            <button
                              className="btn btn-sm btn-primary"
                              style={{ fontWeight: 600, borderRadius: '6px' }}
                              onClick={() => setItemToPay(pro)}
                            >
                              💳 Payer
                            </button>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <h5 style={mobileStyles.emptyMessage}>{messageErrors || "Pas de détails trouvés"}</h5>
              )}

              {!loading && product && product.length > 0 && (
                <div style={{
                  backgroundColor: '#ffffff',
                  border: '1.5px solid #e5e7eb',
                  borderRadius: '12px',
                  padding: '16px',
                  marginTop: '15px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                }}>
                  <span style={{ fontWeight: 700, color: '#1f2937', fontSize: '15px' }}>Total Commande :</span>
                  <span style={{ fontWeight: 800, color: '#F5A623', fontSize: '18px' }}>{totalCommande.toFixed(2)} MAD</span>
                </div>
              )}
              
              {/* {!loading && product && product.length > 0 && (
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                  <a
                    href={`#/commercials/${useParams<{ id: string }>().id}/historiques/${orderId}/rembourser`}
                    style={{
                      padding: "10px 22px", borderRadius: "10px", fontWeight: 600,
                      background: "linear-gradient(135deg,#F5A623,#E8930C)", color: "#fff",
                      border: "none", cursor: "pointer", fontSize: "14px", textDecoration: "none",
                      display: "inline-flex", alignItems: "center", gap: "6px"
                    }}
                  >
                    <i className="bi bi-arrow-counterclockwise" /> Rembourser
                  </a>
                </div>
              )} */}
            </div>
          </div>
        ) : (
          // Desktop View
          <div className="container mt-5" style={{ maxWidth: '1100px', backgroundColor: '#ffffff', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
            <div className="barRetour" style={{ marginBottom: '20px' }}>
              <span className="iconRetour" style={{ fontSize: '28px', cursor: 'pointer', color: '#6366f1', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                <i onClick={handleGoBack} className="bi bi-arrow-left-short"></i>
                <span onClick={handleGoBack} style={{ fontSize: '18px', fontWeight: 500 }}>Retour</span>
              </span>
            </div>

            <h4 className="mb-4" style={{ fontWeight: 700, color: '#1f2937' }}>
              Détails de la commande{' '}
              <span style={{ fontFamily: 'monospace', color: '#6366f1', fontSize: '0.9em' }}>
                {formatCodeCommande(undefined, orderId)}
              </span>
            </h4>
            
            {loading ? (
              <div style={{ textAlign: 'center', padding: '60px 0' }}>
                <div className="spinner-border text-primary" role="status"></div>
                <p style={{ marginTop: '10px', color: '#6b7280' }}>Chargement des détails...</p>
              </div>
            ) : product && product.length > 0 ? (
              <table className="table table-hover" style={{ borderRadius: '8px', overflow: 'hidden' }}>
                <thead className="table-light">
                  <tr>
                    <th scope="col">Réf Article</th>
                    <th scope="col">Article</th>
                    <th scope="col">Prix</th>
                    <th scope="col">Quantité</th>
                    <th scope="col">Vendeur</th>
                    <th scope="col">Statut</th>
                    <th scope="col">Action</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {product.map((pro) => (
                    <tr key={pro.idCommande}>
                      <td style={{ fontWeight: 600, color: '#4b5563' }}>{pro.RefArticle}</td>
                      <td style={{ fontWeight: 500, color: '#1f2937' }}>{pro.NomArticle}</td>
                      <td>{pro.prix} MAD</td>
                      <td>{pro.quantity}</td>
                      <td>{pro.vendeur}</td>
                      <td>
                        <span className="badge" style={{
                          padding: '6px 12px',
                          borderRadius: '20px',
                          color: (pro.Statut || "").toLowerCase().includes("pay") || pro.Statut === "confirmé" ? "#065f46" : pro.Statut === "annulé" ? "#991b1b" : "#92400e",
                          backgroundColor: (pro.Statut || "").toLowerCase().includes("pay") || pro.Statut === "confirmé" ? "#d1fae5" : pro.Statut === "annulé" ? "#fee2e2" : "#fef3c7"
                        }}>
                          {pro.Statut}
                        </span>
                      </td>
                      <td>
                        {(() => {
                          const sLower = (pro.Statut || "").toLowerCase();
                          if (sLower.includes("pay") || sLower.includes("confirm")) {
                            return <span style={{ color: "#10b981", fontWeight: 600, fontSize: "13px" }}>✓ Payé</span>;
                          }
                          if (sLower.includes("annul")) {
                            return <span style={{ color: "#9ca3af" }}>—</span>;
                          }
                          return (
                            <button
                              className="btn btn-sm btn-primary"
                              style={{ fontWeight: 600, borderRadius: "6px", fontSize: "12px", padding: "4px 10px" }}
                              onClick={() => setItemToPay(pro)}
                            >
                              💳 Payer
                            </button>
                          );
                        })()}
                      </td>
                      <td style={{ color: '#6b7280' }}>{pro.created_at}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <h5 style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>{messageErrors || "Pas de détails trouvés"}</h5>
            )}

            {/* {!loading && product && product.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                <a
                  href={`#/commercials/${useParams<{ id: string }>().id}/historiques/${orderId}/rembourser`}
                  style={{
                    padding: "10px 22px", borderRadius: "10px", fontWeight: 600,
                    background: "linear-gradient(135deg,#F5A623,#E8930C)", color: "#fff",
                    border: "none", cursor: "pointer", fontSize: "14px", textDecoration: "none",
                    display: "inline-flex", alignItems: "center", gap: "6px"
                  }}
                >
                  <i className="bi bi-arrow-counterclockwise" /> Rembourser
                </a>
              </div>
            )} */}
          </div>
        )}
      </div>

      {localSuccess && (
        <div style={{
          position: "fixed", bottom: "24px", right: "24px", zIndex: 9999,
          backgroundColor: "#10b981", color: "#fff", padding: "12px 20px",
          borderRadius: "10px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          fontWeight: 600, fontSize: "14px"
        }}>
          ✓ {localSuccess}
        </div>
      )}

      {/* Pay Article Modal */}
      <PayArticleModal
        isOpen={!!itemToPay}
        onClose={() => setItemToPay(null)}
        item={itemToPay}
        buyerType="commercial"
        buyerId={localStorage.getItem("CommercialId") || localStorage.getItem("id")}
        buyerName={localStorage.getItem("CommercialName") || localStorage.getItem("nom") || "Commercial"}
        onSuccess={(newStatut) => {
          if (itemToPay) {
            setState((prev) => ({
              ...prev,
              product: prev.product.map((p) =>
                p.id === itemToPay.id ? { ...p, Statut: newStatut } : p
              ),
            }));
          }
          setLocalSuccess(`Article "${itemToPay?.NomArticle}" payé avec succès.`);
          setTimeout(() => setLocalSuccess(""), 4000);
        }}
      />
    </>
  );
}
